import React, { useEffect, useCallback, useState } from "react";
import {
  UnorderedListOutlined,
  StarOutlined,
  StarFilled,
  CaretUpOutlined,
  CaretDownOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "./css/Sidebar.css";
import { getGlobalMasterLine } from "../../helper/helper";
import { Link } from "react-router-dom";
import BasicInput from "../../components/Input/BasicInput/BasicInput";
import { Col, Row, Tooltip } from "antd";
import {
  clearLocalStoragePreserveEssentials,
  filterMenusFromArray,
  getEnvironment,
  handleCatchFromAPI,
} from "../../utility/util";
import Fuse from "fuse.js";
import { debounce } from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import respository from "../../config/api";

// Logo for sidebar
import Iconbenefit from "../../assets/img/icon/icon_benefit.svg";
import Iconcertificates from "../../assets/img/icon/icon_certificates.svg";
import Iconglobalsetup from "../../assets/img/icon/icon_global_setup.svg";
import Iconlearning from "../../assets/img/icon/icon_learning.svg";
import Iconmain from "../../assets/img/icon/icon_main.svg";
import Iconorganizationadministration from "../../assets/img/icon/icon_organization_administration.svg";
import Iconpayrolladministration from "../../assets/img/icon/icon_payroll_administration.svg";
import Iconperformance from "../../assets/img/icon/icon_performance.svg";
import Iconqualification from "../../assets/img/icon/icon_qualification.svg";
import Iconrecruitment from "../../assets/img/icon/icon_recruitment.svg";
import Iconsystemadministration from "../../assets/img/icon/icon_system_administration.svg";
import Iconworkforceadministration from "../../assets/img/icon/icon_workforce_administration.svg";
import Icontimeattendance from "../../assets/img/icon/icon_time_attendance.svg";
import { useDispatch, useSelector } from "react-redux";
import { setExpandSidebar } from "../../store/slices/sidebarSlice";

const userInfo = JSON.parse(localStorage.getItem("userInfo"));

const listFavoriteStorage = JSON.parse(localStorage.getItem("listFavoriteStorage"));

const iconMap = {
  benefit: Iconbenefit,
  certificates: Iconcertificates,
  globalsetup: Iconglobalsetup,
  learning: Iconlearning,
  main: Iconmain,
  organizationadministration: Iconorganizationadministration,
  payrolladministration: Iconpayrolladministration,
  performance: Iconperformance,
  qualification: Iconqualification,
  recruitment: Iconrecruitment,
  systemadministration: Iconsystemadministration,
  workforceadministration: Iconworkforceadministration,
  timeattendance: Icontimeattendance,
};

// Merged replacement for the old SidebarForDescktop.jsx / SidebarForMobile.jsx duplicate pair.
// variant="desktop" keeps the search box + wider collapsed rail; variant="mobile" hides search
// and collapses the rail to 0 width (via the "sidebar-mobile" CSS modifier), matching the
// previous two components' behavior exactly.
const SidebarMenu = ({ typesMenu, variant = "desktop" }) => {
  const isDesktop = variant === "desktop";
  const urlId = window.location.href.split("/")[5];
  const history = useHistory();
  const dispatch = useDispatch();

  const isExpandSidebar = useSelector((state) => state.sidebar.isExpandSidebar);

  const [listPrimaryMenu, setListPrimaryMenu] = useState([]);
  const [listDataMenu, setlistDataMenu] = useState([]);
  const [selectedMenu, setselectedMenu] = useState(null);
  const [listFavorite, setListFavorite] = useState(listFavoriteStorage || []);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [valueSearchMenu, setValueSearchMenu] = useState("");
  const [searchMenu, setsearchMenu] = useState([]);

  const [openSubmenu, setOpenSubmenu] = useState([]);

  const addIconForHeader = useCallback((res) => {
    const tempRes = res.map((item) => ({
      ...item,
      iconpath: `${item.value.toLowerCase().trim().replace(/\s+/g, "")}`,
    }));

    return tempRes;
  }, []);

  const _getGlobalMasterLine = useCallback(
    (tableName, func) => {
      getGlobalMasterLine(tableName, (res) => {
        const result = addIconForHeader(res);
        func(result);
      });
    },
    [addIconForHeader]
  );

  const handleClickSubmenu = useCallback(
    (menu) => {
      const isOpen = openSubmenu.includes(menu.systemObjectID);

      if (isOpen) {
        // Tutup: hapus ID ini + semua child-nya dari openSubmenu
        const allToRemove = [menu.systemObjectID, ...(menu.childId || [])];
        const filtered = openSubmenu.filter((id) => !allToRemove.includes(id));
        setOpenSubmenu(filtered);
      } else {
        // Buka: tambahkan ID ini
        setOpenSubmenu([...openSubmenu, menu.systemObjectID]);
      }
    },
    [openSubmenu]
  );

  const handleExpendSidebar = useCallback(
    (isShow) => {
      setTimeout(() => {
        dispatch(
          setExpandSidebar({
            isExpandSidebar: isShow,
          })
        );
      }, 80);
    },
    [dispatch]
  );

  const handleFavoriteMenu = (item) => {
    setListFavorite((prev) => {
      const isItemExist = prev.some((prevItem) => prevItem.systemObjectID === item.systemObjectID);

      if (isItemExist) {
        return prev.filter((prevItem) => prevItem.systemObjectID !== item.systemObjectID);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleFindHeaderTitle = useCallback(() => {
    const findRootHeaderTitle = (data, targetId, currentParent = null) => {
      for (const item of data) {
        // Jika item saat ini adalah target, kembalikan headerTitle parent tertinggi
        if (item.systemObjectID === targetId) {
          return currentParent?.headerTitle || item.headerTitle;
        }

        // Jika item memiliki children, lanjutkan pencarian
        if (item.children && item.children.length > 0) {
          const result = findRootHeaderTitle(
            item.children,
            targetId,
            currentParent || item // Update currentParent hanya jika bukan null
          );
          if (result) return result;
        }
      }
      return null; // Tidak ditemukan
    };

    const tempHeader = findRootHeaderTitle(listDataMenu, urlId);

    setselectedMenu(tempHeader);
  }, [listDataMenu, urlId]);

  const flat = useCallback((items) => {
    if (!items) return [];
    let final = [];

    items.map((item) => {
      final.push(item);
      if (item.children) {
        final = final.concat(flat(item.children));
      }
    });
    return final;
  }, []);

  const _getTreeObjectReference = useCallback(() => {
    if (!userInfo) {
      return;
    }

    const params = {
      GroupId: userInfo.userRole,
      environment: getEnvironment(),
    };

    respository.User.getTreeObjectReference(params)
      .then((res) => {
        const data = res.data.result;
        const objectSystem = flat(data);
        localStorage.setItem("objectSystem", JSON.stringify(objectSystem));
      })
      .catch((error) => {
        handleCatchFromAPI(error, "SidebarMenu.jsx", "getTreeReference");
      });
  }, [flat]);

  const redirectToLogin = useCallback(async () => {
    clearLocalStoragePreserveEssentials();
    window.location.href = "/login";
  }, []);

  useEffect(() => {
    if (!userInfo) {
      redirectToLogin();
    }

    try {
      const tempObjectSystem = JSON.parse(localStorage.getItem("objectSystem"));

      if (tempObjectSystem) {
        const filterObjectSystem = tempObjectSystem
          ?.filter((menu) => menu.types === typesMenu)
          .map((menu) => ({
            name: menu.name,
            iconpath: menu.icon,
            label: menu.headerTitle,
            title: menu.headerTitle,
            value: menu.headerTitle,
            systemObjectID: menu.systemObjectID,
            types: menu.types,
            uri: menu.uri,
            addinfo: menu.order,
            children: menu.children,
            access: menu.access,
          }));

        setListPrimaryMenu(filterObjectSystem);

        const temListFavoriteStorage = JSON.parse(localStorage.getItem("listFavoriteStorage"));
        if (temListFavoriteStorage) {
          setListFavorite(temListFavoriteStorage);
        }
      } else {
        _getTreeObjectReference();
      }
    } catch (error) {
      console.error(error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_getGlobalMasterLine, window.location.pathname]);

  useEffect(() => {
    setValueSearchMenu("");
    setOpenSubmenu([]);
  }, [selectedMenu]);

  useEffect(() => {
    localStorage.setItem("listFavoriteStorage", JSON.stringify(listFavorite));
  }, [listFavorite]);

  useEffect(() => {
    if (listDataMenu && !isExpandSidebar) {
      handleFindHeaderTitle();
    }
  }, [handleFindHeaderTitle, isExpandSidebar, listDataMenu, listPrimaryMenu, urlId]);

  const renderChildrenSubmenu = useCallback(
    (menu, idx) => {
      const isItemExist = listFavorite?.some(
        (prevItem) => prevItem.systemObjectID === menu.systemObjectID
      );

      const isModule = String(menu.parentID || "")
        .toLowerCase()
        .includes(typesMenu.toLowerCase());

      const childStyle = isModule
        ? {}
        : {
            marginLeft: 10,
            borderLeft: "3px solid var(--primary-color)",
          };

      const isOpen = openSubmenu.includes(menu.systemObjectID);

      if (menu.children?.length > 0) {
        return (
          <React.Fragment key={`${menu.systemObjectID}_${idx}`}>
            <li
              className="descktop-submenu-1"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClickSubmenu(menu);
              }}
              style={childStyle}
            >
              <h5
                className="title-submenu-1"
                style={{ marginBottom: 0, cursor: "pointer", padding: "5px 15px" }}
              >
                {isOpen ? (
                  <CaretUpOutlined style={{ color: "var(--primary-color)" }} />
                ) : (
                  <CaretDownOutlined style={{ color: "var(--primary-color)" }} />
                )}{" "}
                {menu.name}
              </h5>
            </li>
          </React.Fragment>
        );
      }

      if (menu.uri && menu.children?.length === 0) {
        return (
          <li
            key={`${menu.systemObjectID}_${idx}`}
            className="descktop-submenu-1"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleClickSubmenu(menu);
              history.push(menu?.uri || "#");
              setselectedMenu(null);
              handleExpendSidebar(false);
            }}
            style={childStyle}
            onMouseEnter={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setHoveredIndex(menu.systemObjectID);
            }}
            onMouseLeave={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setHoveredIndex(null);
            }}
          >
            <div
              className="menu-subtitle-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                maxWidth: "240px",
              }}
            >
              <div
                className="title-submenu-1"
                style={{
                  marginBottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>{menu.name}</div>
              </div>

              {typesMenu === "Module" ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleFavoriteMenu(menu);
                  }}
                >
                  {!isItemExist && hoveredIndex === menu.systemObjectID && (
                    <Tooltip title="Favorite">
                      <StarOutlined style={{ color: "var(--primary-color)" }} />
                    </Tooltip>
                  )}
                  {isItemExist && hoveredIndex === menu.systemObjectID && (
                    <Tooltip title="Unfavorite">
                      <StarFilled style={{ color: "var(--primary-color)" }} />
                    </Tooltip>
                  )}
                </span>
              ) : (
                <span />
              )}
            </div>
          </li>
        );
      }

      {
        isOpen && menu.children.map((child, childIdx) => renderChildrenSubmenu(child, childIdx));
      }

      return null;
    },
    [
      handleClickSubmenu,
      handleExpendSidebar,
      history,
      hoveredIndex,
      listFavorite,
      openSubmenu,
      typesMenu,
    ]
  );

  const sliceArrAccordingNums = useCallback((datas, num) => {
    const arr = [];
    const tempNum = datas.length < num ? datas.length : num;

    for (let idx = 0; idx < datas.length; idx += tempNum) {
      arr.push(datas.slice(idx, idx + tempNum));
    }

    return arr;
  }, []);

  const handleFindSearchResult = useCallback((filterListMenu, fuseResult) => {
    const pathSet = new Set();
    const resultMap = new Map();

    const findNodeByID = (nodes, id) => {
      for (const node of nodes) {
        if (node.systemObjectID === id) return node;
        if (node.children?.length) {
          const found = findNodeByID(node.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const buildPathToRoot = (node) => {
      const path = [];
      let current = node;
      while (current) {
        path.unshift(current);
        current = findNodeByID(filterListMenu, current.parentID);
      }
      return path;
    };

    const buildTreeFromPath = (path) => {
      let currentLevel = resultMap;
      for (const node of path) {
        if (!currentLevel.has(node.systemObjectID)) {
          currentLevel.set(node.systemObjectID, { ...node, children: new Map() });
        }
        currentLevel = currentLevel.get(node.systemObjectID).children;
      }
    };

    for (const node of fuseResult) {
      const path = buildPathToRoot(node);
      const pathKey = path.map((p) => p.systemObjectID).join("-");
      if (!pathSet.has(pathKey)) {
        pathSet.add(pathKey);
        buildTreeFromPath(path);
      }
    }

    // convert Map to array recursively
    const mapToArray = (map) => {
      return Array.from(map.values()).map((item) => ({
        ...item,
        children: mapToArray(item.children),
      }));
    };

    const finalResult = mapToArray(resultMap);

    // Optionally buka semua ID
    const allOpenIDs = [...pathSet].flatMap((key) => key.split("-"));
    setOpenSubmenu((prev) => [...new Set([...prev, ...allOpenIDs])]);

    return finalResult;
  }, []);

  const debouncedSearch = debounce((val, filterListMenu, setsearchMenu) => {
    const fuse = new Fuse(filterListMenu, {
      keys: ["name"],
      includeScore: false,
      threshold: 0.1,
      ignoreLocation: true,
      isCaseSensitive: false,
    });
    const fuseResult = fuse.search(val).map(({ item }) => item);

    const tempResult = handleFindSearchResult(filterListMenu, fuseResult);

    setsearchMenu(tempResult);
  }, 200); // 200ms debounce

  const handleSearchMenu = useCallback(
    (val) => {
      setValueSearchMenu(val);

      if (!val) {
        setOpenSubmenu([]);
      }

      const filterListMenu = listDataMenu.sort((a, b) => a.order - b.order);

      const listMenuObjInArr = handleListMenuObjInArr(filterListMenu);

      debouncedSearch(val, listMenuObjInArr, setsearchMenu);
    },
    [debouncedSearch, handleListMenuObjInArr, listDataMenu]
  );

  const getChildId = useCallback((menu) => {
    let tempChildId = [];

    menu.children.forEach((item) => {
      tempChildId.push(item.systemObjectID);
      if (item.children.length > 0) {
        tempChildId = tempChildId.concat(getChildId(item));
      }
    });

    return tempChildId;
  }, []);

  const handleListMenuObjInArr = useCallback(
    (menus) => {
      const result = [];

      const traverse = (menu) => {
        const hasChildren = menu.children?.length > 0;

        const newItem = {
          ...menu,
          ...(hasChildren ? { childId: getChildId(menu) } : {}),
        };

        result.push(newItem);

        if (hasChildren) {
          menu.children.forEach(traverse);
        }
      };

      menus.forEach(traverse);

      return result;
    },
    [getChildId]
  );

  const renderFavoriveMenu = useCallback(
    (menus) => {
      const listMenus = menus;

      let rowLimit = 12;

      let widthContainer = 300;

      const totalFilter = Math.ceil(listMenus.length / 12);

      if (totalFilter > 3 && totalFilter < 6) {
        rowLimit = 20;
      }

      if (totalFilter > 5) {
        rowLimit = 30;
      }

      const listMenuForRender = sliceArrAccordingNums(listMenus, rowLimit);

      widthContainer = 300 * Math.round(listMenus.length / 10);

      const renderMenu = () => {
        return listMenuForRender.map((arrMenu, idx) => {
          return (
            <Col className="gutter-row" span={24 / listMenuForRender.length} key={idx}>
              {arrMenu.map((menu, idxSec) => {
                const isItemExist = listFavorite?.some(
                  (prevItem) => prevItem.systemObjectID === menu.systemObjectID
                );

                return (
                  <li
                    key={`${menu.systemObjectID}_${idxSec}`}
                    className="descktop-submenu-1"
                    onMouseEnter={(e) => {
                      e.preventDefault();
                      setHoveredIndex(menu.systemObjectID);
                    }}
                    onClick={() => history.push(menu?.uri || "#")}
                  >
                    <div
                      className="menu-subtitle-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        maxWidth: "250px",
                      }}
                    >
                      <div className="title-submenu-1" style={{ marginBottom: 0 }}>
                        <div>{menu.name}</div>
                      </div>

                      {typesMenu === "Module" ? (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFavoriteMenu(menu);
                          }}
                        >
                          {!isItemExist && hoveredIndex === menu.systemObjectID && (
                            <Tooltip title="Favorite">
                              <StarOutlined style={{ color: "var(--primary-color)" }} />
                            </Tooltip>
                          )}
                          {isItemExist && hoveredIndex === menu.systemObjectID && (
                            <Tooltip title="Unfavorite">
                              <StarFilled style={{ color: "var(--primary-color)" }} />
                            </Tooltip>
                          )}
                        </span>
                      ) : (
                        <span />
                      )}
                    </div>
                  </li>
                );
              })}
            </Col>
          );
        });
      };

      return (
        <div
          className={`modal-list-menu ${"favorite" === selectedMenu && "expand-modal-list-menu"}`}
          style={{
            width: `${widthContainer < 300 ? 300 : widthContainer}px`,
          }}
        >
          <div style={{ padding: "5px 15px" }}>
            <div className="d-flex align-items-center mb-2">
              <StarFilled style={{ color: "var(--primary-color)" }} className="mr-2" />{" "}
              <h4 className="mb-0">Favorite</h4>
            </div>
          </div>
          <Row gutter={[16, 16]}>{renderMenu()}</Row>
        </div>
      );
    },
    [history, hoveredIndex, listFavorite, selectedMenu, sliceArrAccordingNums, typesMenu]
  );

  const renderListDataMenu = useCallback(
    (menuCategory) => {
      const tempListMenu = valueSearchMenu?.length ? searchMenu : menuCategory.children;

      const filterListMenu = tempListMenu
        .filter((item) => item.access === "1")
        .sort((a, b) => a.order - b.order);

      let rowLimit = 12;

      let widthContainer = 300;

      const listMenuObjInArr = handleListMenuObjInArr(filterListMenu);

      const filterListMenuObjInArr = listMenuObjInArr.filter(
        (menu) =>
          (openSubmenu.includes(menu.parentID) ||
            menu.parentID?.toLowerCase()?.includes(typesMenu.toLowerCase())) &&
          menu.access === "1"
      );

      const totalFilter = Math.ceil(listMenuObjInArr.length / 12);

      if (totalFilter > 3 && totalFilter < 6) {
        rowLimit = 20;
      }

      if (totalFilter > 5) {
        rowLimit = 30;
      }

      const listMenuForRender = sliceArrAccordingNums(filterListMenuObjInArr, rowLimit);

      widthContainer = 300 * Math.round(listMenuObjInArr.length / 12);

      const renderMenu = () => {
        return listMenuForRender.map((arrMenu, idx) => {
          return (
            <Col className="gutter-row" span={24 / listMenuForRender.length} key={idx}>
              {arrMenu
                .filter(
                  (menu) =>
                    (menu.headerTitle === "Main" && menu.order === 1) || menu.headerTitle !== "Main"
                )
                .map((menu, idxSec) => {
                  const isItemExist = listFavorite?.some(
                    (prevItem) => prevItem.systemObjectID === menu.systemObjectID
                  );

                  const isModule = String(menu.parentID || "")
                    .toLowerCase()
                    .includes(typesMenu.toLowerCase());

                  if (menu.uri && isModule) {
                    return (
                      <li
                        key={`${menu.systemObjectID}_${idxSec}`}
                        className="descktop-submenu-1"
                        onMouseEnter={(e) => {
                          e.preventDefault();
                          setHoveredIndex(menu.systemObjectID);
                        }}
                        onMouseLeave={(e) => {
                          e.preventDefault();
                          setHoveredIndex(null);
                        }}
                        onClick={() => {
                          history.push(menu?.uri || "#");
                          setselectedMenu(null);
                          handleExpendSidebar(false);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            maxWidth: "250px",
                            marginLeft: "15px",
                          }}
                        >
                          <div className="title-submenu-1" style={{ marginBottom: 0 }}>
                            <div>{menu.name}</div>
                          </div>

                          {typesMenu === "Module" ? (
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFavoriteMenu(menu);
                              }}
                            >
                              {!isItemExist && hoveredIndex === menu.systemObjectID && (
                                <Tooltip title="Favorite">
                                  <StarOutlined style={{ color: "var(--primary-color)" }} />
                                </Tooltip>
                              )}
                              {isItemExist && hoveredIndex === menu.systemObjectID && (
                                <Tooltip title="Unfavorite">
                                  <StarFilled style={{ color: "var(--primary-color)" }} />
                                </Tooltip>
                              )}
                            </span>
                          ) : (
                            <span />
                          )}
                        </div>
                      </li>
                    );
                  }

                  if ((!menu.uri && isModule && menu.children.length > 0) || !isModule) {
                    return renderChildrenSubmenu(menu);
                  }
                })}
            </Col>
          );
        });
      };

      const Icon = iconMap[menuCategory.iconpath];

      return (
        <div
          className={`modal-list-menu ${
            menuCategory.value === selectedMenu && "expand-modal-list-menu"
          }`}
          style={{
            width: `${widthContainer < 500 ? 500 : widthContainer}px`,
          }}
        >
          <div style={{ padding: "5px 15px" }} className="mb-3">
            <div className="d-flex align-items-center mb-3">
              {menuCategory.iconpath && (
                <Icon
                  style={{ height: "24px", width: "24px", color: "var(--primary-color)" }}
                  className="mr-2 mb-0"
                />
              )}
              <h4 className="mb-0">{menuCategory.value}</h4>
            </div>
            {isDesktop && (
              <BasicInput
                placeholder="Search menu..."
                value={valueSearchMenu}
                onChange={(val) => handleSearchMenu(val)}
                styleInput={{ maxWidth: "300px" }}
              />
            )}
          </div>
          {tempListMenu && <Row gutter={[16, 16]}>{renderMenu()}</Row>}

          {!tempListMenu && <div className="text-center">Menu Not Found</div>}
        </div>
      );
    },
    [
      isDesktop,
      valueSearchMenu,
      searchMenu,
      handleListMenuObjInArr,
      sliceArrAccordingNums,
      selectedMenu,
      openSubmenu,
      typesMenu,
      listFavorite,
      hoveredIndex,
      history,
      handleExpendSidebar,
      renderChildrenSubmenu,
      handleSearchMenu,
    ]
  );

  const renderListPrimaryMenu = useCallback(() => {
    let filterOnlyMenu = [];

    if (listPrimaryMenu?.length > 0) {
      filterOnlyMenu = filterMenusFromArray(listPrimaryMenu);
    }

    return filterOnlyMenu
      .filter((item) => item.access === "1")
      .sort((a, b) => Number(a.addinfo) - Number(b.addinfo))
      .map((item, idx) => {
        const Icon = iconMap[item.iconpath];

        return (
          <ul key={`${item.value}_${idx}`}>
            <li
              className="sidebar-all-list-menu"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setselectedMenu(item.value);
                setlistDataMenu(item.children);
              }}
              style={{
                background: item.value === selectedMenu ? "#eeeeeeaa" : "#fff",
              }}
            >
              <Link to="#">
                <div>
                  {item.iconpath && Icon && (
                    <Icon
                      style={{
                        height: "24px",
                        width: "24px",
                        color: "var(--primary-color)",
                      }}
                    />
                  )}
                  {(!item.iconpath || !Icon) && (
                    <UnorderedListOutlined
                      style={{
                        color: "var(--primary-color)",
                      }}
                    />
                  )}
                </div>
                {isExpandSidebar && <span>{item.name}</span>}
                {item.value === selectedMenu &&
                  item.children?.length > 0 &&
                  renderListDataMenu(item)}
              </Link>
            </li>
          </ul>
        );
      });
  }, [isExpandSidebar, listPrimaryMenu, renderListDataMenu, selectedMenu]);

  return (
    <div id="sidebar-new" className={isDesktop ? "" : "sidebar-mobile"}>
      <div
        className={`menu-primary ${isExpandSidebar ? "menu-primary-expand" : ""}`}
        onMouseEnter={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleExpendSidebar(true);
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleExpendSidebar(false);
          setselectedMenu(null);
        }}
      >
        <div className="scroll-container" style={{ height: "100%", overflow: "auto" }}>
          {typesMenu === "Setup" && (
            <ul>
              <li
                className="sidebar-all-list-menu"
                onMouseEnter={() => setselectedMenu("favorite")}
                onMouseLeave={() => setselectedMenu(null)}
                style={{
                  background: "favorite" === selectedMenu ? "#eeeeeeaa" : "#fff",
                }}
              >
                <Link
                  to={`/app/main/home`}
                  style={{ weight: "100%", height: "100%" }}
                  onClick={() => handleExpendSidebar(false)}
                >
                  <div className="icon">
                    <span
                      style={{
                        width: "24px",
                        height: "24px",
                        border: "2px solid var(--primary-color)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ArrowLeftOutlined
                        style={{ fontSize: "16px", color: "var(--primary-color)" }}
                      />
                    </span>
                  </div>
                  {isExpandSidebar && <span>Back to Main</span>}
                </Link>
              </li>
            </ul>
          )}

          {listFavorite.length > 0 && typesMenu === "Module" && (
            <ul>
              <li
                className="sidebar-all-list-menu"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setselectedMenu("favorite");
                }}
                onMouseLeave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setselectedMenu(null);
                }}
                style={{
                  background: "favorite" === selectedMenu ? "#eeeeeeaa" : "#fff",
                }}
              >
                <Link to="#">
                  <div className="icon">
                    <StarFilled style={{ fontSize: "24px", color: "var(--primary-color)" }} />
                  </div>
                  {isExpandSidebar && <span>Favorite</span>}
                  {"favorite" === selectedMenu && renderFavoriveMenu(listFavorite)}
                </Link>
              </li>
            </ul>
          )}

          {listPrimaryMenu.length > 0 && renderListPrimaryMenu()}
        </div>
      </div>
    </div>
  );
};

export default SidebarMenu;
